import React, { useState } from "react";

export type DropdownProps = {
  id: string;
  name: string;
  label: string;
  isError: boolean;
  errorText: string;
  defaultValue?: string;
  triggerOption: string;
  triggerOptionLabel: string;
  triggerOptionValue: string;
  selectId: string;
  selectValue: string;
  options: Array<{ label: string; value: string }>;
  onChange?: (value: string) => void;
};

function Dropdown({
  id,
  name,
  defaultValue = "",
  isError = false,
  selectId = "",
  label = "",
  options,
  triggerOption = "",
  triggerOptionLabel = "Please specify",
  triggerOptionValue: initialTriggerOptionValue,
  errorText = "required",
  onChange,
}: DropdownProps) {
  const defaultOption = options.filter((o) => o.value === defaultValue);
  const isTriggerOption = defaultOption.length === 0 && defaultValue.length > 0;

  const [selectValue, setSelectValue] = useState(
    isTriggerOption ? triggerOption : defaultValue,
  );
  const [value, setValue] = useState(defaultValue);
  const [triggerOptionValue, setTriggerOptionValue] = useState(
    isTriggerOption ? defaultValue : initialTriggerOptionValue,
  );

  const handleChangeTriggerOptionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setTriggerOptionValue(value);
    setValue(value);

    if (onChange && value !== triggerOption) {
      onChange(value);
    }
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectValue(value);
    setValue(value);

    if (onChange && value !== triggerOption) {
      onChange(value);
    }
  };

  const renderTriggerOptionField = () => (
    <div className="form-group">
      <label id="trigger-option-label">{triggerOptionLabel}</label>
      <input
        type="text"
        value={triggerOptionValue}
        onChange={handleChangeTriggerOptionChange}
        className="input-text border rounded border-gray-600"
      />
    </div>
  );

  const renderError = () => (
    <div className="error-text">
      <i className="material-icons">&#xE001;</i>
      <span>{errorText}</span>
    </div>
  );

  return (
    <>
      <div className={"form-group" + (isError ? " field_with_errors" : "")}>
        <label htmlFor={selectId}>{label}</label>
        <select
          id={selectId}
          className="input-text border rounded border-gray-600"
          value={selectValue as string}
          onChange={handleSelectChange}
        >
          <option value="" key={"please_select"} disabled>
            Please select
          </option>
          {options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {selectValue === triggerOption && renderTriggerOptionField()}

      {isError && renderError()}

      <input type="hidden" id={id} name={name} value={value}></input>
    </>
  );
}

export default Dropdown;
